<template lang="pug">
k-page.archive
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( :title='$route.name' )
    the-loop( :posts="posts" :pagers="pagers" )
</template>

<script lang="js">
import TheLoop from '@/components/the-loop'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import { PostList } from '@/mixins'

export default {
  name: 'ArchivePage',
  mixins: [ PostList ],
  components: { TheLoop, KPage, KMain, DMainImage, WGoDown },
  props: [],
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.archive {

}
</style>
